export default __webpack_public_path__ + "thumbs-up-hand-symbol.png";